import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { SocialProof } from '../components/SocialProof';
import { Production } from '../components/Production';
import { Comparison } from '../components/Comparison';
import { Benefits } from '../components/Benefits';
import { Trust } from '../components/Trust';
import { FinalCTA } from '../components/FinalCTA';
import { QuoteForm } from '../components/QuoteForm';
import { ArtworkHelp } from '../components/ArtworkHelp';
import { FAQ } from '../components/FAQ';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="min-h-screen bg-white font-sans text-black overflow-x-hidden" data-id="element-260">
      <Header data-id="element-261" />
      <main data-id="element-262">
        <Hero data-id="element-263" />
        <SocialProof data-id="element-264" />
        <Production data-id="element-265" />
        <ArtworkHelp data-id="element-266" />
        <QuoteForm data-id="element-267" />
        <Comparison data-id="element-268" />
        <Benefits data-id="element-269" />
        <Trust data-id="element-270" />
        <FinalCTA data-id="element-271" />
        <FAQ data-id="element-272" />
      </main>
      <Footer data-id="element-273" />
    </div>;
}